<form [formGroup]="formGroup">
  <div *ngIf="connectionObjectData?.gisId || connectionObjectData?.corridorNumber">
    <button
      [matTooltip]="
        'Übernehmen Sie die Adresse aus dem Anlagenstandort (Ort, Postleitzahl, Straße und Hausnummer sofern vorhanden)'
      "
      mat-stroked-button
      color="primary"
      (click)="copyConnectionObjectAddress()"
      style="margin: 1em 0">
      <mat-icon style="margin-right: 0.25em">content_copy</mat-icon>
      Objektanschrift übernehmen
    </button>
  </div>

  <app-contact-address-formpart [formGroup]="formGroup" [disable]="disable" />
  <app-contact-details-formpart
    [formGroup]="formGroup"
    [disable]="disable"
    [differsFromCurrentUser]="differsFromCurrentUser" />
</form>
